export default __webpack_public_path__ + "static/media/wishlist.fe08be9f.svg";